import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  changelayoutMode,
  showRightSidebarAction
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import SubscriptionExpiredOverlay from "../Common/SubscriptionExpiredOverlay";
import FreePlanFallbackModal from "../Common/FreePlanFallbackModal";
import FeatureTrialBanner from "../Common/FeatureTrialBanner";
import { PlanFeatureProvider } from "../../context/PlanFeatureContext";
import OnboardingTour from "../../feautures/onboarding/OnboardingTour";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
const Layout = props => {
  const dispatch = useDispatch();

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      topbarTheme: layout.topbarTheme,
      layoutWidth: layout.layoutWidth,
      isPreloader: layout.isPreloader,
      leftSideBarTheme: layout.leftSideBarTheme,
      layoutType: layout.layoutType,
      layoutMode: layout.layoutMode,
      leftSideBarType: layout.leftSideBarType,

      leftSidebarTypes: layout.leftSidebarTypes,
    })
  );
  const {
    topbarTheme,
    layoutWidth,
    isPreloader,
    leftSideBarTheme,
    layoutType,
    layoutMode,
    leftSideBarType,
    leftSidebarTypes,
    showRightSidebar
  } = useSelector(selectLayoutProperties);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };



  useEffect(() => {

  
    const preloaderElement = document.getElementById("preloader");
  
    if (preloaderElement) {
      if (isPreloader === true) {
        preloaderElement.style.display = "block";
  
        setTimeout(function () {
          preloaderElement.style.display = "none";
        }, 2500);
      } else {
        preloaderElement.style.display = "none";
      }
    }
  }, [isPreloader]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutMode) {
      dispatch(changelayoutMode(layoutMode, layoutType));
    }
  }, [layoutMode, dispatch, layoutType]);

  useEffect(() => {
    if (leftSidebarTypes) {
      dispatch(changeSidebarType(leftSidebarTypes));
    }
  }, [leftSidebarTypes, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  /*
  call dark/light mode
  */
  const onChangeLayoutMode = (value) => {
    if (changelayoutMode) {
      dispatch(changelayoutMode(value, layoutType));
    }
  };

  // Paket özellikleri + deneme durumu tek kaynaktan: sidebar menüyü buna göre
  // çizer, FeatureTrialBanner sayacı buradan okur, "Aboneliğim" ekranı da aynı
  // veriyi paylaşır — üçü ayrı ayrı istek atmasın diye provider layout'ta durur.
  return (
    <PlanFeatureProvider>
    <React.Fragment>
      {!props.suppressOnboarding && <OnboardingTour blocked={props.suppressOnboarding} />}
      <div className="pace pace-active" id="preloader">
        <div className="pace-progress" data-progress-text="100%" data-progress="99" style={{ transform: "translate3d(100%, 0px, 0px)" }}>
          <div className="pace-progress-inner"></div>
        </div>
        <div className="pace-activity"></div></div>

      <div id="layout-wrapper">

        <Header toggleMenuCallback={toggleMenuCallback} onChangeLayoutMode={onChangeLayoutMode} />

        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content" style={{ background: '#f4f6f9', minHeight: '100vh' }}>
          {/* Deneme süresiyle açılmış bir özelliğin sayfasındaysak kalan gün sayacı. */}
          <FeatureTrialBanner />
          {props.children}
          <Footer />
        </div>
      </div>
      <SubscriptionExpiredOverlay />
      <FreePlanFallbackModal />
    </React.Fragment>
    </PlanFeatureProvider>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,

  topbarTheme: PropTypes.any,
  changelayoutMode: PropTypes.func,
  suppressOnboarding: PropTypes.bool
};


export default Layout;
